const events = {
  DATE_SELECTED: 'dateScroller_date_selected',
  SET_DATE: 'dateScroller_set_date',
};

export default events;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/inventoryOverview/dateScroller/events.js